import React, { useState } from "react";

function ProductOverview() {
  const [quantity, setQuantity] = useState(0);
  const add = () => {
    setQuantity(quantity + 1);
  };
  const minus = () => {
    setQuantity(quantity - 1);
  };

  return (
    <div className="bg-white mb-[30vh] flex flex-col gap-2 md:gap-6 items-center justify- md:border border-black/40 pb-20 min-h-screen relative z-50">
      <div className="min-h-[65vh] w-full grid md:grid-cols-2">
        <div className="grid place-items-center border md:border-0 md:border-r md:border-b border-black/40">
          <img src={require("../images/serumbig.png")} alt="" width={600} />
        </div>
        <div className="p-4 md:p-8 relative flex flex-col gap-4">
          <p className="text-4xl md:text-[3rem] font-semibold">
            Skin Serum 100
          </p>
          <p className="text-2xl font-semibold mt-2">$23.50</p>
          <p className="text-base font-medium md:w-10/12 mt-2">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
          <div className="flex flex-col gap-2 mt-3">
            <p className="text-lg font-semibold">Ingredients</p>
            <ol className="font-medium text-sm flex flex-col gap-1">
              <li>- Coconut</li>
              <li>- Vanilla</li>
              <li>- Honey</li>
            </ol>
          </div>
          <div className="mt-4">
            <div className="flex items-center gap-4">
              <div className="w-max bg-neutral-300 flex items-center gap-3 text-[10px] font-semibold uppercase tracking-wide">
                <i
                  onClick={minus}
                  className={`fa-solid fa-minus ${
                    quantity <= 0
                      ? "pointer-events-none bg-white/60"
                      : "pointer-events-auto"
                  } hover:bg-black hover:text-white p-3.5 cursor-pointer`}
                ></i>
                <input
                  value={quantity}
                  className="w-[15px] outline-none bg-transparent outline-0 text-sm"
                />
                <i
                  onClick={add}
                  className={`fa-solid fa-plus ${
                    quantity >= 10
                      ? "pointer-events-none bg-white/60"
                      : "pointer-events-auto"
                  } hover:bg-black hover:text-white p-3.5 cursor-pointer`}
                ></i>
              </div>
            </div>
          </div>
          <div className="w-full lg:absolute lg:bottom-0 md:w-10/12 grid grid-cols-2 gap-4 mt-8">
            <button className="text-sm border-black hover:bg-black hover:text-white bg-transparent border py-3 uppercase font-semibold">
              Add to Cart
            </button>
            <button className="text-sm border-black hover:bg-white bg-black text-white hover:text-black border py-3 uppercase font-semibold">
              Buy now
            </button>
          </div>
        </div>
      </div>
      <div className="w-full">
        <p className="p-4 md:p-8 text-4xl font-semibold">Frequently bought together</p>
        <div className="grid grid-cols-2 md:grid-cols-4 w-full gap-0 relative z-40">
          <div className="bg-white p-2 border-y border-x-[0.5px] border-black/30 flex-grow flex items-center flex-col justify-between h-[350px]">
            <div className="flex-1 grid place-items-center w-full overflow-hidden">
              <img src={require("../images/serum.png")} alt="" className="" />
            </div>
            <div className="w-10/12 flex flex-col gap-1 text-center">
              <p className="text-base font-semibold cursor-pointer hover:underline">
                Skin Serum 100
              </p>
              <p className="text-lg font-semibold">$23.50</p>
              <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
                Add to cart
              </div>
            </div>
          </div>
          <div className="bg-white p-2 border-y border-x-[0.5px] border-black/30 flex-grow flex items-center flex-col justify-between h-[350px]">
            <div className="flex-1 grid place-items-center w-full overflow-hidden">
              <img src={require("../images/serum.png")} alt="" className="" />
            </div>
            <div className="w-10/12 flex flex-col gap-1 text-center">
              <p className="w-full truncate text-base font-semibold cursor-pointer hover:underline">
                Skin Serum 100 Skin Serum 100
              </p>
              <p className="text-lg font-semibold">$23.50</p>
              <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
                Add to cart
              </div>
            </div>
          </div>
          <div className="bg-white p-2 border-y border-x-[0.5px] border-black/30 flex-grow flex items-center flex-col justify-between h-[350px]">
            <div className="flex-1 grid place-items-center w-full overflow-hidden">
              <img src={require("../images/serum.png")} alt="" className="" />
            </div>
            <div className="w-10/12 flex flex-col gap-1 text-center">
              <p className="text-base font-semibold cursor-pointer hover:underline">
                Skin Serum 100
              </p>
              <p className="text-lg font-semibold">$23.50</p>
              <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
                Add to cart
              </div>
            </div>
          </div>
          <div className="bg-white p-2 border-y border-x-[0.5px] border-black/30 flex-grow flex items-center flex-col justify-between h-[350px]">
            <div className="flex-1 grid place-items-center w-full overflow-hidden">
              <img src={require("../images/serum.png")} alt="" className="" />
            </div>
            <div className="w-10/12 flex flex-col gap-1 text-center">
              <p className="text-base font-semibold cursor-pointer hover:underline">
                Skin Serum 100
              </p>
              <p className="text-lg font-semibold">$23.50</p>
              <div className="text-xs bg-black hover:bg-white border border-black hover:text-black text-white p-4 uppercase font-semibold text-center cursor-pointer">
                Add to cart
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductOverview;
